import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { PageNotFoundIllustrationSVG } from '../../../svgComponents/pageNotFoundIllustrationSVG';
import messages from './PageNotFoundView.messages';
import { StateView } from '../../pageStructure/stateView/';

export class PageNotFoundView extends Component {
    renderHeaderMessage() {
        return <FormattedMessage {...messages.header} />;
    }

    renderDescriptionMessage() {
        const values = { homeLink: this.renderDescriptionLink() };
        return <FormattedMessage {...messages.description} values={values} />;
    }

    renderDescriptionLink() {
        return (
            <a href="/">
                <FormattedMessage {...messages.descriptionLink} />
            </a>
        );
    }

    renderImage() {
        return <PageNotFoundIllustrationSVG />;
    }

    render() {
        const headerMessage = this.renderHeaderMessage();
        const descriptionMessage = this.renderDescriptionMessage();
        const image = this.renderImage();

        return (
            <StateView
                image={image}
                headerMessage={headerMessage}
                descriptionMessage={descriptionMessage}
            />
        );
    }
}
